// Imports
import React from "react"
import { FajnyIcon, Tabs, Flexbox, Grid, Section, Font } from "fajny-react"

import CodeContainer from "../CodeContainer"

import { Container, StyledButton } from "./styles"

const ContainerIcon = ({ icon }) => {
    const { name, regular, solid, brand } = icon

    const DemoIcon = ({ weight }) => (
        <Flexbox align="center" justify="center">
            <FajnyIcon name={`${name}-${weight}`} size={64} color="primary" />
        </Flexbox>
    )

    const Col = ({ weight }) => (
        <Grid as="section" gap="l">
            <Section as="div" gap="small">
                <Font.H6>Component</Font.H6>

                <CodeContainer>
                    {`<FajnyIcon\n    name="${name}-${weight}"\n    size={64}\n    color="primary"\n/>`}
                </CodeContainer>
            </Section>

            <Section as="div" gap="small">
                <Font.H6>Mixin</Font.H6>

                <CodeContainer>
                    {`&:before {\n    \${Mixins.Icon({\n        $name: "${name}-${weight}",\n        $color: "secondary-400",\n        $size: 48,\n    })};\n}`}
                </CodeContainer>
            </Section>

            <StyledButton href={`/icons/${name}-${weight}.svg`} download>
                <FajnyIcon name="download-solid" size={16} />
                Download
            </StyledButton>
        </Grid>
    )

    const tabItems = [
        {
            title: "Regular",
            content: (
                <Grid col={2} gap="m">
                    <DemoIcon weight="regular" />

                    <Col weight="regular" />
                </Grid>
            ),
        },
        {
            title: "Solid",
            content: (
                <Grid col={2} gap="m">
                    <DemoIcon weight="solid" />

                    <Col weight="solid" />
                </Grid>
            ),
        },
    ]

    return (
        <Container>
            {regular && solid ? (
                <Tabs items={tabItems} />
            ) : !regular && solid ? (
                <Grid col={2} gap="m">
                    <DemoIcon weight="solid" />

                    <Col weight="solid" />
                </Grid>
            ) : brand ? (
                <Grid col={2} gap="m">
                    <DemoIcon weight="brand" />

                    <Col weight="brand" />
                </Grid>
            ) : (
                ""
            )}
        </Container>
    )
}

export default ContainerIcon
